import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import HeroSection from './HeroSection';
import AboutSection from './AboutSection';
import ServicesSection from './ServicesSection';
import ProductsSection from './ProductsSection';
import ReviewsSection from './ReviewsSection';
import FeedSection from './FeedSection';
import ContactSection from './ContactSection';
import MapSection from '../shared/MapSection';
import GMBFeedSection from '../shared/GMBFeedSection';
import TagsSection from '../shared/TagsSection';
import Footer from './Footer';

const TemplateContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  minHeight: '100vh',
  backgroundColor: '#ffffff',
  fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
}));

const Template7 = ({
  templateData,
  isEditable = false,
  onTemplateUpdate
}) => {
  const {
    businessName,
    description,
    services,
    products,
    contact,
    reviews,
    feedPosts,
    location,
    gmbFeed,
    categories
  } = templateData || {};

  return (
    <TemplateContainer>
      <HeroSection
        businessName={businessName}
        description={description}
      />
      <AboutSection description={description} />
      <ServicesSection services={services} />
      <ProductsSection products={products} />
      <ReviewsSection reviews={reviews} businessName={businessName} />
      <MapSection location={location} />
      <GMBFeedSection gmbFeed={gmbFeed} />
      <TagsSection
        businessInfo={{ name: businessName, description }}
        categories={categories}
        products={products}
        contactInfo={contact}
      />
      <FeedSection feedPosts={feedPosts} />
      <ContactSection contact={contact} />

      <Footer contact={contact} />
    </TemplateContainer>
  );
};

export default Template7;
